export async function getIsAppTrackingAuthorized() {
  return true; // this feature is only for iOS.
}
